import { Images } from "../../../Images";
import MineDamageLogic from "../../../logic/MineDamageLogic";
import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import ClassicUpgradeCollection from "../classic/ClassicUpgradeCollection";
import ClassicUpgradeCostCalculator from "../classic/ClassicUpgradeCostCalculator";
import PickUpgrade from "./PickUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";

export default class PickUpgradeCollection extends ClassicUpgradeCollection {
    /**
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(totals, values, mineDamageLogic) {
        super();

        this.initializeUpgrades(totals, values, mineDamageLogic);        
    }

    /**
     * @override
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    initializeUpgrades(totals, values, mineDamageLogic) {

        // procedurally generated upgrades

        let prevUpgrade = null;
        for (let i = 0; i < 100; i++) { // <-- Don't start at 0 - because of math.
            const upgrade = this.generateBaseDamageUpgrade(i, totals, values, mineDamageLogic, prevUpgrade);
            prevUpgrade = upgrade;
        }

        prevUpgrade = null;
        for (let i = 1; i < 100; i++) { // <-- Don't start at 0 - because of math.
            const upgrade = this.generateMultiplicativeUpgrade(i, totals, values, mineDamageLogic, prevUpgrade);
            prevUpgrade = upgrade;
        }

        this.addBulkCompleted();
    }

    /**
     * @private
     * @param {number} i 
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     * @param {PickUpgrade} prevUpgrade
     * @returns {PickUpgrade}
     */
    generateMultiplicativeUpgrade(i, totals, values, mineDamageLogic, prevUpgrade) {

        // 0.25
        // 0.5
        // 0.75
        // 1.0
        const multiplier = i < 10 ? 0.05
            : i < 20 ? 0.1   // + 0.05
            : i < 30 ? 0.2   // + 0.1
            : i < 40 ? 0.35  // + 0.15
            : i < 50 ? 0.45  // + 0.2
            : i < 60 ? 0.7   // + 0.25
            : i < 70 ? 1.0  // + 0.3
            : i < 80 ? 1.35   // + 0.35
            : i < 90 ? 1.75  // + 0.4
            : 2;

        const upgradeValue = new BigNum(multiplier * i);

        const costCalculator = this.createCostCalculator(i);

        const label = 'Multiplier: +' + NumberFormatter.formatBigNum(upgradeValue);

        const upgrade = new PickUpgrade('m' + i, label, Images.pick, 
            costCalculator, totals, mineDamageLogic, 
            values.baseMultiplicativeBonusValue, upgradeValue, prevUpgrade, 20, 150, false);

        this.addBulk(upgrade);

        return upgrade;
    }

    /**
     * @private
     * @param {number} i 
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     * @param {PickUpgrade} prevUpgrade
     * @returns {PickUpgrade}
     */
    generateBaseDamageUpgrade(i, totals, values, mineDamageLogic, prevUpgrade) {
        const valueBase = 1.35; // (1.4,3)=>e44
        const valueExp = 2.5; // 2.5 -> e36    3 -> e44
        /////const valuePerTurn = Math.max(1, Math.floor(Math.pow(valueBase, i * valueExp)));

        const val = i + 0.01;

        const valuePerTurn = new BigNum(valueBase);
        /////valuePerTurn.pow(i * valueExp);
        valuePerTurn.pow(val * valueExp);
        //valuePerTurn.floor();

        // if (valuePerTurn.lessThanNumber(1)) {
        //     valuePerTurn.setValue(1);
        // }
        
        ///const valuePerSecond = valuePerTurn * Settings.time.turnsPerSecond;
        const valuePerSecond = new BigNum(0);
        valuePerSecond.copy(valuePerTurn);
        valuePerSecond.mulNumber(Settings.time.turnsPerSecond);

        const formattedValuePerSecond = NumberFormatter.formatBigNum(valuePerSecond);

        const costCalculator = this.createCostCalculator(i + 1); // +1 because i starts at 0.

        console.log('PICK BASE: i=' + i + ' perTurn=' + NumberFormatter.formatBigNum(valuePerTurn) + ' perSec=' + formattedValuePerSecond);

        const upgrade = new PickUpgrade('add' + i, 'Base: +' + formattedValuePerSecond + '/sec', Images.pick, costCalculator, totals, mineDamageLogic, 
            values.baseAdditiveBonusPerTurn, valuePerTurn, prevUpgrade, 20, 150, true);
       
        this.addBulk(upgrade);

        return upgrade;
    }

    /**
     * @private
     * @param {number} i 
     * @returns {UpgradeCostCalculator}
     */
    createCostCalculator(i) {
        // const costBase = 2;
        // const costExp = 4.4;
        // const costGrowthRate = 1.08;

        const costBase = 2;
        const costExp = 4.4;
        const costGrowthRate = 1.1;

        const cost = Math.max(1, Math.floor(Math.pow(costBase, i * costExp)));
        return new ClassicUpgradeCostCalculator(new BigNum(cost), costGrowthRate);
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }

}

/*

        const valueBase = 1.4;
        const valueExp = 3;
        const valuePerTurn = Math.max(1, Math.floor(Math.pow(valueBase, i * valueExp)));

PICK BASE: i=48 perSec=4.41E21 out.js:23735:15
PICK BASE: i=49 perSec=1.21E22 out.js:23735:15
PICK BASE: i=50 perSec=3.32E22 out.js:23735:15
PICK BASE: i=51 perSec=9.11E22 out.js:23735:15
PICK BASE: i=52 perSec=2.50E23 out.js:23735:15
PICK BASE: i=53 perSec=6.86E23 out.js:23735:15
PICK BASE: i=54 perSec=1.88E24 out.js:23735:15
PICK BASE: i=55 perSec=5.17E24 out.js:23735:15
PICK BASE: i=56 perSec=1.42E25 out.js:23735:15
PICK BASE: i=57 perSec=3.89E25 out.js:23735:15
PICK BASE: i=58 perSec=1.07E26 out.js:23735:15
PICK BASE: i=59 perSec=2.93E26 out.js:23735:15
PICK BASE: i=60 perSec=8.04E26 out.js:23735:15
PICK BASE: i=61 perSec=2.21E27 out.js:23735:15
PICK BASE: i=62 perSec=6.05E27 out.js:23735:15
PICK BASE: i=63 perSec=1.66E28 out.js:23735:15
PICK BASE: i=64 perSec=4.56E28 out.js:23735:15
PICK BASE: i=65 perSec=1.25E29 out.js:23735:15
PICK BASE: i=66 perSec=3.43E29 out.js:23735:15
PICK BASE: i=67 perSec=9.41E29 out.js:23735:15
PICK BASE: i=68 perSec=2.58E30 out.js:23735:15
PICK BASE: i=69 perSec=7.09E30 out.js:23735:15
PICK BASE: i=70 perSec=1.95E31 out.js:23735:15
PICK BASE: i=71 perSec=5.34E31 out.js:23735:15
PICK BASE: i=72 perSec=1.46E32 out.js:23735:15
PICK BASE: i=73 perSec=4.02E32 out.js:23735:15
PICK BASE: i=74 perSec=1.10E33 out.js:23735:15
PICK BASE: i=75 perSec=3.03E33 out.js:23735:15
PICK BASE: i=76 perSec=8.30E33 out.js:23735:15
PICK BASE: i=77 perSec=2.28E34 out.js:23735:15
PICK BASE: i=78 perSec=6.25E34 out.js:23735:15
PICK BASE: i=79 perSec=1.72E35 out.js:23735:15
PICK BASE: i=80 perSec=4.71E35 out.js:23735:15
PICK BASE: i=81 perSec=1.29E36 out.js:23735:15
PICK BASE: i=82 perSec=3.54E36 out.js:23735:15
PICK BASE: i=83 perSec=9.73E36 out.js:23735:15
PICK BASE: i=84 perSec=2.67E37 out.js:23735:15
PICK BASE: i=85 perSec=7.32E37 out.js:23735:15
PICK BASE: i=86 perSec=2.01E38 out.js:23735:15
PICK BASE: i=87 perSec=5.51E38 out.js:23735:15
PICK BASE: i=88 perSec=1.51E39 out.js:23735:15
PICK BASE: i=89 perSec=4.15E39 out.js:23735:15
PICK BASE: i=90 perSec=1.14E40 out.js:23735:15
PICK BASE: i=91 perSec=3.13E40 out.js:23735:15
PICK BASE: i=92 perSec=8.58E40 out.js:23735:15
PICK BASE: i=93 perSec=2.35E41 out.js:23735:15
PICK BASE: i=94 perSec=6.46E41 out.js:23735:15
PICK BASE: i=95 perSec=1.77E42 out.js:23735:15
PICK BASE: i=96 perSec=4.86E42 out.js:23735:15
PICK BASE: i=97 perSec=1.33E43 out.js:23735:15
PICK BASE: i=98 perSec=3.66E43 out.js:23735:15
PICK BASE: i=99 perSec=1.00E44
*/